import React from 'react';
import { 
    Button, 
    Dialog, 
    DialogTitle, 
    DialogActions, 
    DialogContent, 
    DialogContentText 
} from '@mui/material'

export interface ICallback { (): void }
export interface IConfirmActionCallback { (reason?: string): void };
export interface IAction { reason?: string, label: string };

export interface ConfirmationDialogProps {
  rejectActions?: IAction[],
  resolveActions: IAction[],
  title: string,
  open: boolean,
  maxWidth?: number,
  description?: string,
  onClose: ICallback,
  onExited: ICallback,
  onReject: IConfirmActionCallback,
  onResolve: IConfirmActionCallback,
}

export const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  rejectActions=[{reason: 'cancel', label: "Cancel"}],
  resolveActions=[{reason: 'ok', label: "OK"}],
  open=false,
  maxWidth=900,
  onClose=()=>{},
  onExited=()=>{},
  onReject=()=>{},
  onResolve=()=>{},
  ...props
}): JSX.Element => {
  const {title, description} = props;

  const handleReject = (reason: string) => {
    onClose();
    onReject(reason);
  }

  const handleResolve = (reason: string) => {
    onClose();
    onResolve(reason);
  }

  const handleExited = () => {
    onExited();
  }

  const hasRejectActions = (Boolean(rejectActions) && rejectActions.length >= 1);
  const hasResolveActions = (Boolean(resolveActions) && resolveActions.length >= 1);

  const handleClose = () => {
    hasRejectActions ? handleReject(undefined) : handleResolve(undefined);
  }

  const renderActionButton = (index: number, action: IAction, isResolve: boolean) => {
    const variant = isResolve ? "contained" : "outlined" 
    const handler = isResolve ? ()=>{handleResolve(action.reason)} : ()=>{handleReject(action.reason)}
    let key = isResolve ? "resolveaction" : "resolveaction";
    key = key+index;
    const autoFocus = isResolve && (index == (resolveActions.length-1))
    return (
      <Button key={action.label} variant={isResolve==true ? "contained" : "outlined"} autoFocus={autoFocus} color="primary" onClick={handler}>
        {action.label}
      </Button>
    )
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      TransitionProps={{
        onExited: handleExited
      }}
      aria-labelledby="confirmtm-dialog-title"
      aria-describedby="confirmtm-dialog-description"
      PaperProps={{
        style: {minWidth: 300, maxWidth: maxWidth}
      }}
    >
      <DialogTitle id="confirmtm-dialog-title">{title}</DialogTitle>
      { Boolean(description) && (
        <DialogContent>
          <DialogContentText id="confirmtm-dialog-description">
            {description}
          </DialogContentText>
        </DialogContent>
      )}
      <DialogActions>
        { hasRejectActions && rejectActions.map((action, index) => renderActionButton(index, action, false))}
        { hasResolveActions && resolveActions.map((action, index) => renderActionButton(index, action, true))}
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmationDialog;
